/*
 * File: /src/router/routes/knowledge.js
 * Author: AdBase, Inc.
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const KnowledgeList = () =>
  import(
    /* webpackChunkName: "Knowledge" */ 'src/components/Dashboard/Views/Knowledge/KnowledgeList.vue'
  );
const KnowledgeEdit = () =>
  import(
    /* webpackChunkName: "Knowledge" */ 'src/components/Dashboard/Views/Knowledge/KnowledgeEdit.vue'
  );
const KnowledgeUnitView = () =>
  import(
    /* webpackChunkName: "Knowledge" */ 'src/components/Dashboard/Views/Knowledge/KnowledgeUnitView.vue'
  );

export const knowledgeRoutes = [
  {
    path: 'knowledge/list',
    name: 'Knowledge List',
    component: KnowledgeList,
  },
  {
    path: 'knowledge/units',
    name: 'Knowledge By Unit',
    component: KnowledgeUnitView,
  },
  {
    path: 'knowledge/add',
    name: 'Knowledge Add',
    component: KnowledgeEdit,
    props: () => ({
      id: undefined,
    }),
  },
  {
    path: 'knowledge/edit/:id',
    name: 'Knowledge Edit',
    component: KnowledgeEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
];
